import { render, staticRenderFns } from "./EditOnly.vue?vue&type=template&id=d99d709c&scoped=true&"
import script from "./EditOnly.vue?vue&type=script&lang=ts&"
export * from "./EditOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99d709c",
  null
  
)

export default component.exports